import type { HotelIngredient } from '@apps/main/modules/recipe/ingredients';
import type { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import { isDefined } from '@libs/utils';

import { FLEXIBLE_NUMBER_OF_NIGHTS_SYMBOL } from './constants';

const localeStringOptions: Intl.NumberFormatOptions = {
  minimumIntegerDigits: 2,
  useGrouping: false,
};

export function serializeNumberOfNights(
  accommodation: HotelIngredient | OwnStayIngredient
): string {
  if (
    isDefined(accommodation.numberOfNights) &&
    accommodation.numberOfNights.toString().length > 2
  ) {
    return FLEXIBLE_NUMBER_OF_NIGHTS_SYMBOL;
  }

  return (
    accommodation.numberOfNights?.toLocaleString(
      'en-US',
      localeStringOptions
    ) ?? FLEXIBLE_NUMBER_OF_NIGHTS_SYMBOL
  );
}

export function serializeTransportType(
  accommodation: HotelIngredient | OwnStayIngredient
): string {
  return accommodation.transportTypeToBeReached.toLocaleString(
    'en-US',
    localeStringOptions
  );
}
